module.exports = __webpack_public_path__ + "static/debitcard-8f9fd8e0d8dfbc06b3288f28cfed9ef8.jpg";